<header class="topbar">
  <div class="with-vertical">
    <nav class="navbar navbar-expand-lg p-0">
      <div class="d-flex align-items-center w-100 justify-content-between">
        <a
          #menubutton
          href="javascript:void(0)"
          class="nav-link p-0 d-flex align-items-center justify-content-center sidebar-toggle"
          role="button"
          aria-label="Toggle menu"
          (click)="layoutService.onMenuToggle()"
        >
          <lucide-icon [name]="isMenuVisible ? 'PanelLeftClose' : 'PanelLeftOpen'" [size]="18"></lucide-icon>
        </a>

        <div class="ms-auto me-2 user-dropdown" [class.open]="userMenuOpen">
          <a href="javascript:void(0)"
             class="user-trigger"
             (click)="userMenuOpen = !userMenuOpen">
            <div class="user-avatar-topbar">{{ getInitials(user?.name) }}</div>
            <span class="user-name d-none d-md-inline">{{ user?.name }}</span>
            <i class="ti ti-chevron-down fs-6"></i>
          </a>
          <ul class="user-dropdown-menu" *ngIf="userMenuOpen">
            <li>
              <button class="dropdown-item text-danger" type="button" (click)="logout(); userMenuOpen = false">
                <i class="ti ti-logout me-2"></i>Sair
              </button>
            </li>
          </ul>
        </div>
      </div>


    </nav>

  </div>
</header>
